import { render, staticRenderFns } from "./ProductTariff.vue?vue&type=template&id=3a961774&scoped=true"
import script from "./ProductTariff.vue?vue&type=script&lang=js"
export * from "./ProductTariff.vue?vue&type=script&lang=js"
import style0 from "./ProductTariff.vue?vue&type=style&index=0&id=3a961774&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a961774",
  null
  
)

export default component.exports